<template>
  <v-row no-gutters align="center" class="h-screen">
    <!-- Imagen de autenticación -->
    <v-col
      sm="12"
      md="6"
      lg="6"
      class="d-none d-md-flex h-screen bg-primary md:flex-column align-center justify-center"
    >
      <div class="text-center pa-6">
        <h1 class="font-weight-bold alex-brush-regular">Síguenos en:</h1>
        <v-row align="center" justify="center" class="mt-4">
          <v-col cols="auto">
            <v-tooltip text="Nuestra Web" location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon="mdi-web"
                  @click.prevent="viewModel.goToWeb()"
                >
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
          <v-col cols="auto">
            <v-tooltip text="WhatsApp" location="bottom">
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  icon="mdi-whatsapp"
                  @click.prevent="viewModel.goToWhatsApp()"
                ></v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <!-- Formulario de Registro -->
    <v-col
      sm="12"
      md="6"
      lg="6"
      class="flex justify-center align-items-center h-full pa-6"
    >
      <v-card
        class="mx-auto pa-6 pa-md-12 flex justify-center"
        max-width="700"
        border
        flat
      >
        <v-img
          :src="viewModel.logoImage"
          :height="50"
          :width="350"
          cover
          class="h-full w-full mx-auto"
          alt="Logo"
        ></v-img>
        <h4 class="text-h5 font-weight-bold text-center mt-4 mb-8">
          Formulario de Registro
        </h4>

        <v-stepper
          v-model="viewModel.step.value"
          :items="viewModel.stepLabels.value"
          flat
          alt-labels
          color="primary"
          mobile
          class="text-caption"
        >
          <!-- Paso 1 -->
          <!-- eslint-disable-next-line-->
          <template v-slot:item.1>
            <v-card flat>
              <v-card-text class="px-0 text-subtitle-1">
                <span>
                  Proporciona tu número de documento de identidad o RUC para
                  verificar tu registro en
                  <strong>{{ viewModel.appName }}</strong>
                </span>
              </v-card-text>
              <v-form
                ref="formStep1"
                @submit.prevent="viewModel.nextStep"
                class="mt-4"
              >
                <v-text-field
                  v-model="viewModel.dni.value"
                  :rules="viewModel.dniRules"
                  label="Documento de Identidad"
                  required
                  variant="outlined"
                  color="primary"
                  prepend-inner-icon="mdi-card-account-details"
                  hide-details
                ></v-text-field>
              </v-form>
            </v-card>
          </template>

          <!-- Paso 2 -->
          <!-- eslint-disable-next-line-->
          <template v-slot:item.2>
            <v-card flat>
              <v-card-text class="text-subtitle-1">
                <span>
                  Ingresa una dirección de correo válida para futuras
                  comunicaciones.
                </span>
              </v-card-text>
              <v-form
                ref="formStep2"
                @submit.prevent="viewModel.nextStep"
                class="mt-4"
              >
                <v-text-field
                  v-model="viewModel.email.value"
                  label="Correo Electrónico"
                  :rules="viewModel.emailRules"
                  variant="outlined"
                  required
                  color="primary"
                  prepend-inner-icon="mdi-email"
                  hide-details
                ></v-text-field>
              </v-form>
            </v-card>
          </template>

          <!-- Paso 3 -->
          <!-- eslint-disable-next-line-->
          <template v-slot:item.3>
            <v-card flat>
              <v-card-text>
                <span class="text-subtitle-1">
                  Proporciona tu número de teléfono registrado y tu ID de socio.
                </span>
              </v-card-text>
              <v-form
                ref="formStep3"
                @submit.prevent="viewModel.nextStep"
                class="mt-4"
              >
                <v-text-field
                  v-model="viewModel.phoneNumber.value"
                  label="Número de Teléfono"
                  :rules="viewModel.phoneRules"
                  variant="outlined"
                  required
                  color="primary"
                  prepend-inner-icon="mdi-phone"
                  hide-details
                  class="pb-4"
                ></v-text-field>
                <v-text-field
                  v-model="viewModel.idSocio.value"
                  label="ID de Socio"
                  :rules="viewModel.idSocioRules"
                  variant="outlined"
                  required
                  color="primary"
                  prepend-inner-icon="mdi-account"
                  hide-details
                ></v-text-field>
              </v-form>
            </v-card>
          </template>

          <!-- Paso 4 -->
          <!-- eslint-disable-next-line-->
          <template v-slot:item.4>
            <v-card flat>
              <v-card-text>
                <span class="text-subtitle-1">
                  Configura una pregunta secreta y una respuesta para reforzar
                  la seguridad de tu cuenta.
                </span>
              </v-card-text>
              <v-form
                ref="formStep4"
                @submit.prevent="viewModel.nextStep"
                class="mt-4"
              >
                <v-select
                  v-model="viewModel.question.value"
                  :items="viewModel.secretQuestions"
                  label="Selecciona una pregunta secreta"
                  :rules="[(v) => !!v || 'Selecciona una pregunta']"
                  variant="outlined"
                  required
                  color="primary"
                ></v-select>
                <v-text-field
                  v-model="viewModel.answer.value"
                  :type="viewModel.isAnswerVisible.value ? 'text' : 'password'"
                  label="Respuesta secreta"
                  :rules="viewModel.answerRules"
                  variant="outlined"
                  required
                  color="primary"
                  hide-details
                  prepend-inner-icon="mdi-lock-question"
                >
                  <template v-slot:append-inner>
                    <v-btn
                      variant="plain"
                      @click="viewModel.toggleAnswerVisibility"
                    >
                      <v-icon>{{
                        viewModel.isAnswerVisible.value
                          ? "mdi-eye-off"
                          : "mdi-eye"
                      }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-form>
            </v-card>
          </template>

          <!-- Paso 5 -->
          <!-- eslint-disable-next-line-->
          <template v-slot:item.5>
            <v-card flat>
              <v-card-text>
                <span class="text-subtitle-1">
                  Configura una contraseña segura para tu cuenta. La contraseña
                  debe tener al menos 6 caracteres, una letra mayúscula y un
                  número.
                </span>
              </v-card-text>
              <v-form
                ref="formStep5"
                @submit.prevent="viewModel.nextStep"
                class="mt-4"
              >
                <v-text-field
                  v-model="viewModel.password.value"
                  :type="viewModel.isPwdVisible.value ? 'text' : 'password'"
                  label="Contraseña"
                  :rules="viewModel.passwordRules"
                  variant="outlined"
                  required
                  color="primary"
                  hide-details
                  prepend-inner-icon="mdi-lock"
                >
                  <template v-slot:append-inner>
                    <v-btn
                      variant="plain"
                      @click="viewModel.togglePasswordVisibility"
                    >
                      <v-icon>{{
                        viewModel.isPwdVisible.value ? "mdi-eye-off" : "mdi-eye"
                      }}</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-form>
            </v-card>
          </template>

          <!-- Acciones -->
          <template v-slot:actions>
            <div class="d-flex justify-space-between pt-4 mx-0 px-6">
              <v-btn
                variant="outlined"
                @click="viewModel.previousStep()"
                :disabled="
                  viewModel.step.value === 1 || viewModel.loading.value
                "
                class="text-none"
              >
                Atrás
              </v-btn>
              <v-btn
                color="primary"
                class="text-white rounded-md text-none"
                :loading="viewModel.loading.value"
                @click="viewModel.nextStep()"
              >
                {{
                  viewModel.step.value === 5
                    ? "Finalizar Registro"
                    : "Siguiente"
                }}
              </v-btn>
            </div>
            <v-col cols="12" class="pt-8">
              <p class="text-center flex justify-center items-center">
                <span class="text-subtitle-1">¿Ya estas registrado?</span>
                <router-link class="text-subtitle-1 text-primary" to="login">
                  Inicia Sesión
                </router-link>
              </p>
            </v-col>
          </template>
        </v-stepper>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup>
import RegisterViewModel from "@/viewmodels/auth/RegisterViewModel";

const viewModel = new RegisterViewModel();
</script>
